import React from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { proceduresBreadcrumbsHistory } from 'js/utilities/admin-tools';

const ProceduresBreadcrumbs = () => {
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="procedures-breadcrumbs"
      history={proceduresBreadcrumbsHistory(t)}
    />
  );
};

export default ProceduresBreadcrumbs;
